import React from 'react'
import close from '../../assets/images/close.svg'

const AddLocationMenu = ({ showAddInput, newLocationName, setNewLocationName, error, handleSaveLocation, setShowAddInput, refrence, setError, styles, isLoadingAddLocation }) => {
    return (
        <>
            {showAddInput && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box add-new-user" ref={refrence}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => setShowAddInput(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>Add Location</div>
                        <div className={styles.addMenuContent}>
                            <div style={{marginBottom : 16}}>
                                <input
                                    type="text"
                                    value={newLocationName}
                                    onChange={(e) => {setNewLocationName(e.target.value); setError("")}}
                                    placeholder="Enter location name"
                                    className={styles.menuAddInput}
                                />

                                {error && (
                                    <p className='error-message'>{error}</p>
                                )}
                            </div>

                            <button
                                className={`${styles.addBtn} addLocation`}
                                onClick={handleSaveLocation}
                            >
                                {isLoadingAddLocation ? <div className={`ringLoader`}></div> : 'Save'}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default AddLocationMenu;